export default "__VITE_ASSET__D336aOoB__"